import _ from 'lodash';

import { checkIfUserIsNew } from '../reducers/user/resources';
import constants from '../constants';

export async function checkIfNewUser() {
	const user = await checkIfUserIsNew();
	if(!user.data){
		return false;
	}
	const { new_user: newUser, userproducts, userbots } = user.data;

	const data = { isNewUser: false };
	if (newUser) {
		let hasSms = checkIfHasService(userproducts, 'sms');
		if (hasSms) {
			const sms = _.find(userbots, ubot => {
				return ubot.botmap.type === hasSms;
			});
			hasSms = sms ? false : true;
		}

		let isAutoSMB = checkIfHasService(userproducts,'autosmb');
		
		data.isNewUser = true;
		data.isAutoSMB = isAutoSMB ? true : false;
		data.hasSms = hasSms;
	}

	return data;
}

export function checkIfHasService(userproducts, type) {
	const products = _.map(userproducts, 'product');
	let services = _.map(products, 'services');

	services = _.uniq(_.flatten(services));

	let hasSms;
	services.forEach(srvc => {
		if (constants.services[type].includes(srvc)) {
			hasSms = srvc;
		}
	});

	return hasSms;
}
